import styled from 'styled-components';

import { Icon } from '@controlrooms/components';

export const TrendIcon = styled(Icon)`
  display: inline-flex;
`;
